import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Outlet } from "@tanstack/react-router";

import Header from "./components/header";
import useShowJSD from "../../hooks/useShowJSD";

function ProtectedLayout({
  children,
}: {
  children?: React.ReactNode;
}): React.JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useShowJSD({ isAuth: true });

  return (
    <>
      <Header />
      <Container sx={{ flexGrow: 1 }}>
        <Stack
          p={isMobile ? 3 : 4}
          sx={{ paddingLeft: "16px", paddingRight: "16px" }}
        >
          <Box width="100%">{children ?? <Outlet />}</Box>
        </Stack>
      </Container>
    </>
  );
}

export default ProtectedLayout;
